<template>
    <div class="col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
        <empty-state
                class="mt-5"
                fullscreen
                icon="printer"
                title="Print the asset label to get started">
            <slot>
                <button class="btn btn-info btn-lg btn-block mt-4" @click="printLabel()">Print asset label</button>
            </slot>
        </empty-state>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        props: ['assetId'],

        computed: {
            ...mapGetters([
                'asset',
            ])
        },

        mounted() {
            this.loadAsset({
                assetId: this.assetId
            });
        },

        methods: {
            ...mapActions([
                'loadAsset',
                'printAssetLabel'
            ]),

            /** Print the label and continue */
            printLabel() {
                this.printAssetLabel(this.assetId).then(() => {
                    this.$router.push({name: 'bulkRepairDiagnostics.confirmProblems', params:{assetId: this.assetId}});
                });
            }
        }
    }
</script>

<style scoped>

</style>